var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 281,
    height: 194,
    viewBox: "0 0 281 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M24.243 48.553L8.155 51.2.11 2.957 16.195.307z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "32.309%",
    x2: "66.541%",
    y1: "28.602%",
    y2: "70.01%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M3.968 26.515c-4.68 11.641-4.592 25.134.243 36.744 1.927-1.156 3.18-1.733 5.14-2.858-3.825-10.698-3.976-22.643-.43-33.43C12.47 16.184 19.66 6.61 29.081.198 17.516 5.302 8.646 14.843 3.968 26.515"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "-.001%",
    x2: "99.996%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#74D604"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.51 34.167c.155 12.551 5.382 24.98 14.314 33.886 1.348-1.794 2.296-2.799 3.64-4.56-7.614-8.448-12.355-19.45-13.212-30.756C4.394 21.403 7.391 9.854 13.633.339 4.886 9.429.358 21.613.511 34.167"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "-.001%",
    x2: "99.996%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#74D604"
  })), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M2.103 28.915C-1.414 40.98-.01 54.382 5.956 65.474c1.806-1.338 3.029-2.037 4.805-3.374-4.835-10.273-6.149-22.125-3.703-33.217C9.536 17.821 15.747 7.577 24.494.285c-11.011 6.2-18.873 16.563-22.391 28.63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "-.001%",
    x2: "99.996%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#74D604"
  })), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M2.134 28.63C-1.38 40.693.026 54.095 5.99 65.19c1.836-1.337 3.031-2.036 4.805-3.373-4.832-10.273-6.15-22.125-3.703-33.22C9.57 17.536 15.778 7.295 24.528.002 13.517 6.2 5.655 16.562 2.134 28.63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "-.001%",
    x2: "99.996%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#74D604"
  })), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M2.134 29.004C-1.38 41.07.026 54.473 5.99 65.564c1.836-1.305 3.031-2.004 4.805-3.373-4.832-10.27-6.15-22.125-3.703-33.217C9.57 17.912 15.778 7.671 24.528.376 13.517 6.576 5.655 16.939 2.134 29.004"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: ".001%",
    x2: "99.998%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9EFF31"
  })), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M5.607 24.36c-5.75 11.183-6.944 24.617-3.213 36.62 2.02-.939 3.336-1.396 5.354-2.369-2.783-11.001-1.806-22.914 2.721-33.339C14.997 14.848 23.073 6.003 33.045.472 21.085 4.486 11.355 13.177 5.607 24.36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "-.001%",
    x2: "99.996%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#74D604"
  })), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M7.212.284C4.399.255 1.522 1.896.546 4.541c-1.103 2.978.307 6.23 1.71 9.087a8808.927 8808.927 0 0 1 9.515 19.48c1.07 2.188 2.14 4.376 3.733 6.229 1.59 1.826 3.76 3.283 6.176 3.496 2.419.213 5.047-1.064 5.935-3.313.551-1.428.367-3.039.155-4.527a77.7 77.7 0 0 0-8.167-24.587c-1.318-2.494-2.785-4.924-4.833-6.838C12.74 1.674 10.086.284 7.303.284h-.091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M48.138.799c-6.202 1.722-10.472 8.61-9.201 14.9-1.248-5.951-5.3-9.574-10.467-8.336-5.17 1.247-8.627 6.442-9.42 11.671-.797 5.227.488 10.515 1.772 15.651-1.528-3.373-4.956-5.804-8.656-6.2-3.67-.396-7.523 1.306-9.727 4.286-3.394 4.618-2.51 11.124-.37 16.411 6.03 14.74 22.363 25.316 38.177 22.67 5.14-.848 10.31-3.221 13.061-7.625 2.754-4.407 2.143-11.003-2.232-13.83 4.19-1.67 8.411-3.615 11.622-6.837 3.184-3.193 5.202-7.902 4.072-12.248-1.132-4.347-5.964-7.78-10.28-6.352 5.996-2.462 9.392-9.908 7.28-15.986C62.008 3.872 56.656.378 51.286.378a11.81 11.81 0 0 0-3.147.42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: "70.482%",
    x2: "76.44%",
    y1: "31.898%",
    y2: "4.203%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3A8F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#75D12B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M15.562 3.874c-3.361 4.134-2.874 10.82 1.073 14.436-3.701-3.435-8.23-3.98-11.105-.702-2.876 3.284-2.692 8.422-.701 12.312 1.988 3.89 5.413 6.838 8.745 9.662-2.66-1.519-6.117-1.548-8.81-.03C2.105 41.072.329 44.051.3 47.09c-.06 4.711 3.673 8.662 7.65 11.185 11.132 7.021 27.192 6.352 36.523-2.917 3.027-3.009 5.354-7.082 5.108-11.338-.275-4.254-3.853-8.417-8.137-8.234 2.018-3.13 3.915-6.444 4.495-10.092.61-3.647-.334-7.747-3.151-10.18-2.813-2.43-7.737-2.371-9.971.607C35.66 11.62 34.346 5.028 30 1.928 28.252.68 26.125.084 23.981.084c-3.178 0-6.39 1.319-8.419 3.79"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: "70.502%",
    x2: "33.747%",
    y1: "13.849%",
    y2: "94.568%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#25944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#63AF12"
  })), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M17.61 25.357a30.661 30.661 0 0 1-14.559-10.15c3.701 5.623 8.962 10.485 14.956 13.646.642 5.379 1.287 10.789 1.563 16.167-6.792.58-13.768-1.246-19.395-5.075 5.108 5.168 12.237 7.994 19.454 7.84.061 2.585.061 5.198-.123 7.782 1.134-2.767 1.9-5.897 2.418-9.058 5.721-1.672 10.645-5.957 13.305-11.273-3.15 4.132-7.8 7.11-12.876 8.296.243-2.066.396-4.073.49-6.017a51.34 51.34 0 0 0-.279-9.058A56.033 56.033 0 0 0 32.416 12.2c-2.448 4.862-6.119 9.026-10.4 12.368-1.194-7.083-3.455-14.194-5.628-24.315-.613 8.329.244 16.717 1.223 25.104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: ".001%",
    x2: "100.003%",
    y1: "50.002%",
    y2: "50.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#90E800"
  })), /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M.365.043h67.19v7.301H.366z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M.175.043h37.69v7.301H.174z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#DEDEDE",
    opacity: 0.605
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.074 120.37h69.815a3.611 3.611 0 0 1 0 7.223H57.074a3.611 3.611 0 1 1 0-7.223zM25.778 137.222h68.61a3.611 3.611 0 1 1 0 7.222h-68.61a3.611 3.611 0 1 1 0-7.222zM4.111 120.37H33a3.611 3.611 0 1 1 0 7.223H4.111a3.611 3.611 0 1 1 0-7.223z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.56 79.412)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M24.243 48.553L8.155 51.2.11 2.957 16.195.307z",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E6",
    d: "M179.275 83.889l3.55-7.596 5.81 6.078 8.047 48.23-9.36 1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9B9B9",
    d: "M188.637 82.37l-5.812-6.078 16.09-2.674 5.812 6.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E7E6",
    d: "M181.973 71.26l16.083-2.647.839 5.005-16.088 2.65z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.434 3.035)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M3.968 26.515c-4.68 11.641-4.592 25.134.243 36.744 1.927-1.156 3.18-1.733 5.14-2.858-3.825-10.698-3.976-22.643-.43-33.43C12.47 16.184 19.66 6.61 29.081.198 17.516 5.302 8.646 14.843 3.968 26.515",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.434 .216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M.51 34.167c.155 12.551 5.382 24.98 14.314 33.886 1.348-1.794 2.296-2.799 3.64-4.56-7.614-8.448-12.355-19.45-13.212-30.756C4.394 21.403 7.391 9.854 13.633.339 4.886 9.429.358 21.613.511 34.167",
    mask: "url(#i)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.989 9.267)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M2.103 28.915C-1.414 40.98-.01 54.382 5.956 65.474c1.806-1.338 3.029-2.037 4.805-3.374-4.835-10.273-6.149-22.125-3.703-33.217C9.536 17.821 15.747 7.577 24.494.285c-11.011 6.2-18.873 16.563-22.391 28.63",
    mask: "url(#l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.544 17.18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M2.134 28.63C-1.38 40.693.026 54.095 5.99 65.19c1.836-1.337 3.031-2.036 4.805-3.373-4.832-10.273-6.15-22.125-3.703-33.22C9.57 17.536 15.778 7.295 24.528.002 13.517 6.2 5.655 16.562 2.134 28.63",
    mask: "url(#o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.544 23.4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M2.134 29.004C-1.38 41.07.026 54.473 5.99 65.564c1.836-1.305 3.031-2.004 4.805-3.373-4.832-10.27-6.15-22.125-3.703-33.217C9.57 17.912 15.778 7.671 24.528.376 13.517 6.576 5.655 16.939 2.134 29.004",
    mask: "url(#r)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.399 32.45)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M5.607 24.36c-5.75 11.183-6.944 24.617-3.213 36.62 2.02-.939 3.336-1.396 5.354-2.369-2.783-11.001-1.806-22.914 2.721-33.339C14.997 14.848 23.073 6.003 33.045.472 21.085 4.486 11.355 13.177 5.607 24.36",
    mask: "url(#u)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E5B450",
    d: "M140.274 43.682c2.63 1.002 4.651 3.283 5.842 5.803 1.196 2.523 1.685 5.32 1.988 8.117.982 8.63.49 17.414-1.405 25.863-.337 1.518-.765 3.068-1.806 4.193-1.621 1.794-4.557 2.007-6.73.943-2.202-1.066-3.7-3.222-4.493-5.503-.797-2.278-1.011-4.74-1.196-7.14-.58-7.203-1.132-14.408-1.712-21.61-.244-3.16-.367-6.684 1.744-9.055 1.865-2.098 5.168-2.584 7.768-1.611"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.533 34.157)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D55644",
    d: "M7.212.284C4.399.255 1.522 1.896.546 4.541c-1.103 2.978.307 6.23 1.71 9.087a8808.927 8808.927 0 0 1 9.515 19.48c1.07 2.188 2.14 4.376 3.733 6.229 1.59 1.826 3.76 3.283 6.176 3.496 2.419.213 5.047-1.064 5.935-3.313.551-1.428.367-3.039.155-4.527a77.7 77.7 0 0 0-8.167-24.587c-1.318-2.494-2.785-4.924-4.833-6.838C12.74 1.674 10.086.284 7.303.284h-.091",
    mask: "url(#w)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD180",
    d: "M173.969 56.385l24.346 72.726-40.926 4.408-27.071-71.633z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.497 43.764)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M48.138.799c-6.202 1.722-10.472 8.61-9.201 14.9-1.248-5.951-5.3-9.574-10.467-8.336-5.17 1.247-8.627 6.442-9.42 11.671-.797 5.227.488 10.515 1.772 15.651-1.528-3.373-4.956-5.804-8.656-6.2-3.67-.396-7.523 1.306-9.727 4.286-3.394 4.618-2.51 11.124-.37 16.411 6.03 14.74 22.363 25.316 38.177 22.67 5.14-.848 10.31-3.221 13.061-7.625 2.754-4.407 2.143-11.003-2.232-13.83 4.19-1.67 8.411-3.615 11.622-6.837 3.184-3.193 5.202-7.902 4.072-12.248-1.132-4.347-5.964-7.78-10.28-6.352 5.996-2.462 9.392-9.908 7.28-15.986C62.008 3.872 56.656.378 51.286.378a11.81 11.81 0 0 0-3.147.42",
    mask: "url(#z)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#51B148",
    d: "M231.705 103.188c-1.772 2.614-3.64 5.166-5.657 7.596 3.088-1.943 6.056-4.496 8.81-7.263 6.852 2.342 14.773 1.52 21.166-1.853-6.056 1.885-12.756 1.582-18.63-.82a109.58 109.58 0 0 0 4.742-5.593 66.265 66.265 0 0 0 6.149-9.148 68.607 68.607 0 0 0 21.23-9.177c-5.844 3.068-12.421 4.65-19.028 4.953 3.794-7.809 6.639-16.441 11.654-27.959-6.546 7.84-11.654 16.715-16.61 25.68-4.31-5.835-6.882-12.977-7.187-20.21-.276 8.145 1.469 16.653 5.138 23.948-3.211 5.804-6.393 11.58-9.939 17.08-7.128-4.164-12.726-10.85-15.57-18.569 1.375 8.662 6.39 16.473 13.732 21.335"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.092 27.925)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "C",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M15.562 3.874c-3.361 4.134-2.874 10.82 1.073 14.436-3.701-3.435-8.23-3.98-11.105-.702-2.876 3.284-2.692 8.422-.701 12.312 1.988 3.89 5.413 6.838 8.745 9.662-2.66-1.519-6.117-1.548-8.81-.03C2.105 41.072.329 44.051.3 47.09c-.06 4.711 3.673 8.662 7.65 11.185 11.132 7.021 27.192 6.352 36.523-2.917 3.027-3.009 5.354-7.082 5.108-11.338-.275-4.254-3.853-8.417-8.137-8.234 2.018-3.13 3.915-6.444 4.495-10.092.61-3.647-.334-7.747-3.151-10.18-2.813-2.43-7.737-2.371-9.971.607C35.66 11.62 34.346 5.028 30 1.928 28.252.68 26.125.084 23.981.084c-3.178 0-6.39 1.319-8.419 3.79",
    mask: "url(#C)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.497 35.282)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M17.61 25.357a30.661 30.661 0 0 1-14.559-10.15c3.701 5.623 8.962 10.485 14.956 13.646.642 5.379 1.287 10.789 1.563 16.167-6.792.58-13.768-1.246-19.395-5.075 5.108 5.168 12.237 7.994 19.454 7.84.061 2.585.061 5.198-.123 7.782 1.134-2.767 1.9-5.897 2.418-9.058 5.721-1.672 10.645-5.957 13.305-11.273-3.15 4.132-7.8 7.11-12.876 8.296.243-2.066.396-4.073.49-6.017a51.34 51.34 0 0 0-.279-9.058A56.033 56.033 0 0 0 32.416 12.2c-2.448 4.862-6.119 9.026-10.4 12.368-1.194-7.083-3.455-14.194-5.628-24.315-.613 8.329.244 16.717 1.223 25.104",
    mask: "url(#F)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD180",
    d: "M198.14 83.13l6.944 44.28 52.702-5.653 10.553-45.223z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.775 185.76)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M67.556 3.693c0 2.018-15.04 3.652-33.595 3.652C15.407 7.345.365 5.711.365 3.693c0-2.016 15.042-3.65 33.596-3.65 18.554 0 33.595 1.634 33.595 3.65",
    mask: "url(#H)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.081 185.76)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M37.864 3.693c0 2.018-8.438 3.652-18.843 3.652C8.61 7.345.175 5.711.175 3.693.175 1.677 8.61.043 19.02.043c10.405 0 18.843 1.634 18.843 3.65",
    mask: "url(#J)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBFB4",
    d: "M280.992 53.512H119.12l32.07 82.253 113.983-11.57 15.82-70.683zm-4.258 3.395l-14.362 64.161-108.938 11.058-29.327-75.22h152.627z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BEBFB4",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M179.229 56.385v75.894M228.314 56.385v66.578M137.94 91.359h131.573"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBFB4",
    d: "M113.662 30.15c-2.738-7.216-9.798-12.065-17.564-12.065H83.44a1.917 1.917 0 0 0-1.918 1.91c0 1.051.861 1.905 1.918 1.905h12.69c6.172 0 11.786 3.848 13.974 9.575l52.994 136.128c.273.762.97 1.253 1.772 1.253.234 0 .435-.036.598-.113 1.075-.412 1.57-1.49 1.185-2.484l-52.991-136.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#423B40",
    d: "M176.373 183.213c0-3.677 3.027-6.684 6.728-6.684 3.7 0 6.725 3.007 6.725 6.684s-3.025 6.684-6.725 6.684c-3.701 0-6.728-3.007-6.728-6.684M253.365 183.213c0-3.677 3.025-6.684 6.728-6.684 3.7 0 6.725 3.007 6.725 6.684s-3.024 6.684-6.725 6.684c-3.703 0-6.728-3.007-6.728-6.684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBFB4",
    d: "M165.51 172.42c0-1.338 1.074-2.402 2.42-2.402h107.335a2.394 2.394 0 0 1 2.416 2.401 2.396 2.396 0 0 1-2.416 2.403H167.959a2.442 2.442 0 0 1-2.448-2.403"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e074eeeb.svg";
export { ForwardRef as ReactComponent };